export const tokens = {
  colors: {
    white: 'rgba(255,255,255,1)',
    darkWhite: 'rgba(230,230,230,1)',
    disabledWhite: 'rgba(255,255,255,0.5)',
    fontColour: 'rgba(51,51,51,1)',
    fontColour90: 'rgba(51,51,51,0.90)',   // E6
    fontColour85: 'rgba(51,51,51,0.85)',   // D9
    fontColour15: 'rgba(51,51,51,0.15)',   // 26
    fontColour08: 'rgba(51,51,51,0.08)',   // 14
    fontColour50: 'rgba(51,51,51,0.5)',
    fontColour25: 'rgba(51,51,51,0.25)',
    fontColour10: 'rgba(51,51,51,0.1)',
    fontColour8: 'rgba(51,51,51,0.8)',
    fontColour80: 'rgba(51,51,51,0.8)',

    disabledFontColour: 'rgba(153,153,153,1)',
    headerFontColour: 'rgba(51,51,51,1)',
    bodyBackgroundColor: 'rgba(249,250,251,1)',
    titleBackgroundColor: 'rgba(227,227,227,1)',
    panelTitleBackgroundColor: 'rgba(245,245,245,1)',
    defaultGridHeaderBackground: 'rgba(245,245,245,1)',
    darkgray: 'rgba(102,102,102,1)',
    bodyBorderColor: 'rgba(204,204,204,1)',
    bodyBorderColor50: 'rgba(204,204,204,0.5)', // 80 hex ~ 0.5
    bodyHoverBackgroundColor: 'rgba(240,248,255,1)',
    bodyHoverBackgroundColor50: 'rgba(240,248,255,0.5)',
    defaultGridBorderColor: 'rgba(235,235,235,1)',
    defaultGridRowColor: 'rgba(255,255,255,1)',
    defaultGridRowAltColor: 'rgba(255,255,255,1)',
    defaultGridHoverColor: 'rgba(242,244,246,1)',
    defaultGridColor: 'rgba(2,8,23,1)',
    defaultGridSelectionColor: 'rgba(240,248,255,1)',
    verylightgray: 'rgba(248,248,248,1)',
    disabledBackground: 'rgba(248,248,248,1)',
    error: 'rgba(211,47,47,1)',
    gray: 'rgba(133,133,133,1)',
    scrollbarThumb: 'rgba(51,51,51,0.2)',
    scrollbarTrack: 'rgba(0,0,0,0.05)',
    buyBgColor: 'rgba(69, 181, 110, 1)',
    sellBgColor: 'rgba(239, 68, 68, 1)',
    sellFontColor: 'rgba(243, 41, 41, 1)',
    buyFontColor: 'rgba(16, 163, 70, 1)',
    buyBorderColor: 'rgba(5, 150, 105, 1)',
    //orangish
    amberColor: 'rgba(245,166,35,1)',
  },
  palette: {
    // primary base and alpha variants (rgba)
    primary: 'rgba(0,113,206,1)',           // 0x0071ce
    primaryA90: 'rgba(0,113,206,0.90)',     // E6
    primaryA85: 'rgba(0,113,206,0.85)',     // D9
    primaryA80: 'rgba(0,113,206,0.80)',     
    primaryA30: 'rgba(0,113,206,0.30)',     // 4D ~ 0.30
    primaryA25: 'rgba(0,113,206,0.25)',     // 40 ~ 0.25
    primaryA10: 'rgba(0,113,206,0.10)',     // 1A ~ 0.10
    primaryA08: 'rgba(0,113,206,0.08)',     // 14 ~ 0.08
    primaryA04: 'rgba(0,113,206,0.04)',     // 0A ~ 0.04 (muted)
    secondary: 'rgba(47,164,249,1)',        // 0x2FA4F9
    secondaryA10: 'rgba(47,164,249,0.10)',
    danger: 'rgba(211,47,47,1)',
  },
  typography: {
    fontFamilyDefault: '"Inter", sans-serif',
  },
};

// Write tokens to CSS :root so index.css can read --dt-* variables
export function applyTokensToRoot() {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const c = tokens.colors;
  const p = tokens.palette;
  const t = tokens.typography;

  // design-token variables (primary source)
  root.style.setProperty('--dt-white', c.white);
  root.style.setProperty('--dt-font-colour', c.fontColour);
  root.style.setProperty('--dt-font-colour-90', c.fontColour90);
  root.style.setProperty('--dt-font-colour-85', c.fontColour85);
  root.style.setProperty('--dt-font-colour-15', c.fontColour15);
  root.style.setProperty('--dt-font-colour-08', c.fontColour08);
  root.style.setProperty('--dt-header-font-colour', c.headerFontColour);
  root.style.setProperty('--dt-body-background-color', c.bodyBackgroundColor);
  root.style.setProperty('--dt-title-background-color', c.titleBackgroundColor);
  root.style.setProperty('--dt-panel-title-background-color', c.panelTitleBackgroundColor);
  root.style.setProperty('--dt-default-grid-header-background', c.defaultGridHeaderBackground);
  root.style.setProperty('--dt-darkgray', c.darkgray);
  root.style.setProperty('--dt-gray', c.gray);
  root.style.setProperty('--dt-body-border-color', c.bodyBorderColor);
  root.style.setProperty('--dt-body-border-color-50', c.bodyBorderColor50);
  root.style.setProperty('--dt-default-grid-border-color', c.defaultGridBorderColor);
  root.style.setProperty('--dt-verylightgray', c.verylightgray);
  root.style.setProperty('--dt-scrollbar-thumb', c.scrollbarThumb);
  root.style.setProperty('--dt-scrollbar-track', c.scrollbarTrack);

  // semantic palette
  root.style.setProperty('--dt-primary', p.primary);
  root.style.setProperty('--dt-primary-a90', p.primaryA90);
  root.style.setProperty('--dt-primary-a85', p.primaryA85);
  root.style.setProperty('--dt-primary-a30', p.primaryA30);
  root.style.setProperty('--dt-primary-a25', p.primaryA25);
  root.style.setProperty('--dt-primary-a10', p.primaryA10);
  root.style.setProperty('--dt-primary-a08', p.primaryA08);
  root.style.setProperty('--dt-primary-a04', p.primaryA04);
  root.style.setProperty('--dt-secondary', p.secondary);
  root.style.setProperty('--dt-secondary-a10', p.secondaryA10);
  root.style.setProperty('--dt-danger', p.danger);

  // typography
  root.style.setProperty('--dt-font-family-default', t.fontFamilyDefault);

  // Mirror to legacy variable names for backwards compatibility (rgba strings)
  root.style.setProperty('--white', c.white);
  root.style.setProperty('--font-colour', c.fontColour);
  root.style.setProperty('--header-font-colour', c.headerFontColour);
  root.style.setProperty('--body-background-color', c.bodyBackgroundColor);
  root.style.setProperty('--title-background-color', c.titleBackgroundColor);
  root.style.setProperty('--default-grid-header-background', c.defaultGridHeaderBackground);
  root.style.setProperty('--darkgray', c.darkgray);
  root.style.setProperty('--gray', c.gray);
  root.style.setProperty('--default-grid-border-color', c.defaultGridBorderColor);
  root.style.setProperty('--verylightgray', c.verylightgray);
  root.style.setProperty('--primary', p.primary);
  root.style.setProperty('--primary-90', p.primaryA90);
  root.style.setProperty('--primary-80', p.primaryA85);
  root.style.setProperty('--primary-30', p.primaryA30);
  root.style.setProperty('--primary-25', p.primaryA25);
  root.style.setProperty('--primary-10', p.primaryA10);
  root.style.setProperty('--primary-08', p.primaryA08);
  root.style.setProperty('--primary-04', p.primaryA04);
  root.style.setProperty('--secondary', p.secondary);
  root.style.setProperty('--secondary-10', p.secondaryA10);
  root.style.setProperty('--danger', p.danger);
  root.style.setProperty('--font-family-default', t.fontFamilyDefault);
}

// Add helper to apply alpha to rgba / rgb / hex color strings
export function withAlpha(color, alpha) {
  if (!color) return color;
  const a = Math.max(0, Math.min(1, Number(alpha)));
  // rgba(...) case
  const rgbaMatch = color.match(/rgba?\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*([0-9.]+))?\s*\)/i);
  if (rgbaMatch) {
    const r = rgbaMatch[1], g = rgbaMatch[2], b = rgbaMatch[3];
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  // hex #rrggbb or #rgb
  const hexMatch = color.replace(/\s+/g, '').match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (hexMatch) {
    let hex = hexMatch[1];
    if (hex.length === 3) {
      hex = hex.split('').map((c) => c + c).join('');
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  // Fallback: return original color (can't parse)
  return color;
}
